import { Component, Input, OnInit } from '@angular/core';
import { EcommerceService } from 'src/app/services/ecommerce.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-electronic-journal',
  templateUrl: './electronic-journal.component.html',
  styleUrls: ['./electronic-journal.component.scss']
})
export class ElectronicJournalComponent implements OnInit {

  @Input() storeId: string = '';

  entries: any[] = [];
  isLoading: boolean = false;
  errorMessage: string = '';

  // Pagination
  currentPage: number = 1;
  totalPages: number = 1;
  totalEntries: number = 0;
  pageSize: number = 50;

  // Filters
  startDate: string = '';
  endDate: string = '';
  selectedPaymentMethod: string = '';
  isTestOnly: boolean = false;

  // Detail modal
  showEntryDetails: boolean = false;
  selectedEntry: any = null;

  Math = Math;

  paymentMethods = [
    { value: '', label: 'All' },
    { value: 'card', label: 'Card' },
    { value: 'card_terminal', label: 'Card Terminal' },
    { value: 'cash', label: 'Cash' },
    { value: 'mobile', label: 'Mobile' },
    { value: 'wallet', label: 'Wallet' }
  ];

  constructor(
    private ecommerceService: EcommerceService,
    private toastr: ToastrService
  ) {}

  ngOnInit(): void {
    if (this.storeId) {
      this.loadEntries();
    }
  }

  loadEntries(): void {
    this.isLoading = true;
    this.errorMessage = '';

    const params: any = {
      page: this.currentPage,
      limit: this.pageSize
    };

    if (this.startDate) { params['startDate'] = this.startDate; }
    if (this.endDate) { params['endDate'] = this.endDate; }
    if (this.selectedPaymentMethod) { params['paymentMethod'] = this.selectedPaymentMethod; }
    if (this.isTestOnly) { params['isTestReceipt'] = 'true'; }

    this.ecommerceService.getJournalEntries(this.storeId, params).subscribe(
      (res: any) => {
        const data = res?.response?.data ?? res?.data ?? null;
        if (data) {
          this.entries = data.entries || [];
          this.totalEntries = data.total ?? 0;
          this.totalPages = data.totalPages ?? 1;
          this.currentPage = data.page ?? 1;
        } else {
          this.entries = [];
        }
        this.isLoading = false;
      },
      (error: any) => {
        this.errorMessage = error?.error?.response?.message || 'Failed to load journal entries';
        this.toastr.error(this.errorMessage);
        this.isLoading = false;
      }
    );
  }

  applyFilters(): void {
    this.currentPage = 1;
    this.loadEntries();
  }

  resetFilters(): void {
    this.startDate = '';
    this.endDate = '';
    this.selectedPaymentMethod = '';
    this.isTestOnly = false;
    this.currentPage = 1;
    this.loadEntries();
  }

  onPageChange(page: number): void {
    this.currentPage = page;
    this.loadEntries();
  }

  viewEntryDetails(entry: any): void {
    this.selectedEntry = entry;
    this.showEntryDetails = true;
  }

  closeEntryDetails(): void {
    this.showEntryDetails = false;
    this.selectedEntry = null;
  }

  formatCurrency(amount: number, currency: string = 'DKK'): string {
    if (amount == null) { return '—'; }
    return new Intl.NumberFormat('da-DK', {
      style: 'currency',
      currency: currency || 'DKK'
    }).format(amount);
  }

  formatPaymentMethod(method: string): string {
    const map: any = {
      card: 'Card',
      card_terminal: 'Card Terminal',
      cash: 'Cash',
      mobile: 'Mobile',
      wallet: 'Wallet'
    };
    return map[method] || method;
  }

  trackByEntryId(index: number, entry: any): string {
    return entry._id || index;
  }
}
